<script>
import { mapActions } from 'vuex';
import commonDeleteDialogComponent from '../common-delete-dialog.vue';

export default {
    extends: commonDeleteDialogComponent,
    emits: ['resource-deleted'],

    computed: {
        btnDeleteId() {
            return 'deleteRateCard';
        },

        labels() {
            return {
                deleteBtnText: 'actions.delete',
                deleteHeading: 'dialogs.deleteRateCard.header',
            };
        },
    },

    methods: {
        ...mapActions('rateCards', ['deleteRateCard']),

        async deleteSelectedItem() {
            await this.deleteRateCard({ id: this.resourceId, refreshData: false });
            this.closeAll();
            this.$emit('resource-deleted');
        },
    },
};
</script>
